import React from "react";
import { useTranslation } from "react-i18next";
import { Backdrop, Fade, Modal } from "@material-ui/core";
import { useStyles } from "./AddCardTile.styles";
import { ReactComponent as PlusIcon } from "../../../assets/plus.svg";
import { ReactComponent as CloseIcon } from "../../../assets/cross.svg";
import CircleLoader from "../../common/loader/circle-loader.component";

interface AddCardTileProps {
  onClick: () => void;
  isLoading: boolean;
  variant?: "tile" | "link";
}

const AddCardTile: React.FC<AddCardTileProps> = ({
  onClick,
  isLoading,
  variant = "tile",
}) => {
  const { t } = useTranslation();
  const dir = t("css.side") as "rtl" | "ltr";
  const classes = useStyles();

  const [isConfirmModalOpen, setIsConfirmModalOpen] = React.useState(false);

  const openConfirmModal = () => setIsConfirmModalOpen(true);
  const closeConfirmModal = () => setIsConfirmModalOpen(false);

  const handleConfirm = () => {
    closeConfirmModal();
    onClick();
  };

  return (
    <>
      {variant === "link" ? (
        <button
          type="button"
          className={classes.link}
          onClick={openConfirmModal}
          disabled={isLoading}
        >
          {isLoading ? (
            <CircleLoader size={16} color="#80BB34" />
          ) : (
            <>
              <PlusIcon className={classes.linkPlus} />
              <span>{t("account.AddCard")}</span>
            </>
          )}
        </button>
      ) : (
        <button
          type="button"
          className={classes.container}
          onClick={openConfirmModal}
          disabled={isLoading}
        >
          {isLoading ? (
            <CircleLoader size={32} color="#80BB34" />
          ) : (
            <>
              <PlusIcon className={classes.plus} />
              <span>{t("account.AddCard")}</span>
            </>
          )}
        </button>
      )}

      <Modal
        className={classes.modal}
        open={isConfirmModalOpen}
        onClose={closeConfirmModal}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{ timeout: 500 }}
      >
        <Fade in={isConfirmModalOpen}>
          <div className={classes.modalContainer} dir={dir}>
            <div className={classes.modalHeader}>
              <div className={classes.modalTitle}>
                {t("account.addCardHoldTitle")}
              </div>
              <div className={classes.modalCloseIcon} onClick={closeConfirmModal}>
                <CloseIcon style={{ width: 24, height: 24 }} />
              </div>
            </div>

            <p className={classes.modalMessage}>
              {t("account.addCardHoldMessage")}
            </p>

            <button
              type="button"
              className={classes.modalConfirmButton}
              onClick={handleConfirm}
            >
              {t("common.Continue")}
            </button>

            <span className={classes.modalNotNow} onClick={closeConfirmModal}>
              {t("account.notNow")}
            </span>
          </div>
        </Fade>
      </Modal>
    </>
  );
};

export default AddCardTile;
